<template>
  <div class="app-header">
    <el-header
        :class="[
        isHome
          ? homeActive === 1
            ? 'home-header-one'
            : 'home-header-two'
          : headerTheme == 'light'
          ? 'light-header'
          : headerTheme == 'transparent'
          ? 'transparent-header' : 'dark-header',
          // activeIndex == '/join-us' ? 'light-header' : '',
          // activeIndex.includes('/job-list') ? 'header-six' : '',
      ]"
    >
      <div class="header-container">
        <div class="left">
          <img
              class="logo"
              :src="
              (headerTheme == 'light' || headerTheme == 'transparent')
                ? lightLogo
                : redLogo
            "
              @click="$router.replace('/')"
          />
          <div class="line"></div>
          <div class="text">{{ $theme ? '望见无线未来' : 'ENVISION WIRELESS FUTURE' }}</div>
<!--           v-if="headerTheme!='dark'"-->
          
        </div>
        <div class="right-men">
          <ul :class="headerMenuClass">
            <li
                :class="{
                'menu-item': true,
                'menu-item-home': item.url === '/',
                'menu-item-product': item.url === '/product-center',
                'menu-item-active':
                  item.url == activeIndex ||
                  (item.url.indexOf(activeIndex) > -1 && activeIndex !== '/'),
              }"
                v-for="(item, index) in menuList"
                :key="index"
                @click="headerClick(item, index)"

            >
              <!-- @mouseleave="dropVisible = false"
                @mouseenter="
                  curType = item.type;
                  dropVisible = true;
                  dropIndex = index;
                " -->
              <span>
                {{ $theme ? item.title : item.enName }}
                <!-- <i
                  v-if="
                    item.children ||
                    item.type === 'solution' ||
                    item.type === 'production'
                  "
                  class="el-icon-arrow-down el-icon--right"
                ></i> -->
              </span>
              <!--            <ul-->
              <!--              class="drop-block"-->
              <!--              v-if="item.children && dropVisible && dropIndex == index"-->
              <!--            >-->
              <!--              <li-->
              <!--                v-for="(item1, index1) in item.children"-->
              <!--                @click="headerClick(item1)"-->
              <!--                :class="{-->
              <!--                  'drop-item': true,-->
              <!--                  'drop-item-active': item1.url == activeIndex1,-->
              <!--                }"-->
              <!--                :key="index1"-->
              <!--              >-->
              <!--                {{ item1.title }}-->
              <!--              </li>-->
              <!--            </ul>-->
              <!--            <solution-menu-->
              <!--              v-if="curType === 'solution' && dropVisible && dropIndex == index"-->
              <!--              @close="close"-->
              <!--            ></solution-menu>-->
              <!--            <production-menu-->
              <!--              v-if="-->
              <!--                curType === 'production' && dropVisible && dropIndex == index-->
              <!--              "-->
              <!--              @close="close"-->
              <!--            />-->
            </li>
          </ul>
          <div class="btn" :style="{opacity:headerTheme!='dark' ?1:0,pointerEvents:headerTheme!='dark'?'all':'none'}" @click="onJump">{{ $theme?'English':'Chinese' }}</div>
        </div>
      </div>
    </el-header>
  </div>
</template>

<script>
// import SolutionMenu from "@/components/solution-menu/Index.vue";
// import productionMenu from "@/components/production-menu/Index.vue";
// import lightLogo from '/static/image/logo.png'
import lightLogo from "/static/image/logo.png";
import lightLogoEng from "/static/image/logo-eng.png";
// import darkLogo from '/static/image/dark-logo.png'
import darkLogo from "/static/image/dark-logo.svg";
import redLogo from "/static/image/red-logo.png";
import redLogoEng from "/static/image/red-logo-eng.png";

export default {
  name: "App-Header",
  components: {
    // SolutionMenu,
    // productionMenu,
  },
  data() {
    return {
      lightLogo: this.$theme ? lightLogo : lightLogoEng,
      darkLogo: darkLogo,
      redLogo: this.$theme ? redLogo : redLogoEng,
      activeIndex: "/",
      activeIndex1: "",
      menuList1: [
        {
          title: "首页",
          enName: "HOME",
          url: "/",
        },
        {
          title: "解决方案",
          enName: "SOLUTION",
          url: "/solution",
          type: "solution",
          // children: [
          //   {
          //     title: '智慧林草',
          //     url: '/solution/智慧林草'
          //   },
          //   {
          //     title: '碳中和',
          //     url: '/solution/碳中和'
          //   },
          //   {
          //     title: '智慧环保',
          //     url: '/solution/智慧环保'
          //   },
          // ]
        },
        {
          title: "产品中心",
          enName: "PRODUCT",
          url: "/product-center",
          type: "production",
          // children: [
          //   {
          //     title: '软件产品',
          //     url: '/software-product'
          //   },
          //   {
          //     title: '硬件产品',
          //     url: '/hardware-product'
          //   }
          // ]
        },
        {
          title: "品牌荣誉",
          enName: "HONOR",
          url: "/brand-honor",
        },
        // {
        //   title: '咨询动态',
        //   url: '5'
        // },
        {
          title: "关于汉熵",
          enName: "ABOUT US",
          url: "/on-china-entropy",
        },
        {
          title: "加入我们",
          enName: "JOBS",
          url: "/join-us",
        },
      ],
      menuList2: [
        {
          title: "招聘职位",
          enName: "SOCIAL",
          url: "/job-list/0/0",
        },
        {
          title: "加入我们",
          enName: "JOBS",
          url: "/join-us",
        },
        {
          title: "校园招聘",
          enName: "CAMPUS",
          url: "/job-list/1/0",
        },
        {
          title: "关于汉熵",
          enName: "ABOUT US",
          url: "/on-china-entropy",
        },
      ],
      headerTheme: "light",
      dropVisible: false,
      dropIndex: 0,
      curType: "",
    };
  },
  watch: {
    // 监听 路由变化 初始滚动条
    $route: {
      handler(val) {
        this.$bus.$emit("change-show-header", true);
        this.activeIndex = val.fullPath;
        if (val.fullPath.indexOf("/job-list/1") > -1) {
          this.activeIndex = "/job-list/1/0";
        }
        if (val.fullPath.indexOf("/job-list/0") > -1) {
          this.activeIndex = "/job-list/0/0";
        }
        if (val.fullPath.indexOf("/job-infos/0") > -1) {
          this.activeIndex = "/job-list/0/0";
        }
        if (val.fullPath.indexOf("/job-infos/1") > -1) {
          this.activeIndex = "/job-list/1/0";
        }

        // if (val.fullPath == '/solution/智慧林草') {
        //   this.activeIndex = '/solution'
        //   this.activeIndex1 = '/solution/智慧林草'
        // }
        // if (val.fullPath == '/solution/碳中和') {
        //   this.activeIndex = '/solution'
        //   this.activeIndex1 = '/solution/碳中和'
        // }
        // if (val.fullPath == '/solution/智慧环保') {
        //   this.activeIndex = '/solution'
        //   this.activeIndex1 = '/solution/智慧环保'
        // }

        if (val.fullPath == "/software-product") {
          this.activeIndex = "/product-center";
          this.activeIndex1 = "/software-product";
        }
        if (val.fullPath == "/hardware-product") {
          this.activeIndex = "/product-center";
          this.activeIndex1 = "/hardware-product";
        }
        if (val.fullPath.indexOf("/software-product-detail") > -1) {
          this.activeIndex = "/product-center";
          this.activeIndex1 = "/software-product";
        }
        if (val.fullPath.indexOf("/hardware-product-detail") > -1) {
          this.activeIndex = "/product-center";
          this.activeIndex1 = "/hardware-product";
        }
        if (val.fullPath.indexOf("/solution") > -1) {
          this.activeIndex = "/solution";
        }
        this.headerTheme = val.meta.headerTheme;
        this.setScreenTopTo0();
      },
      immediate: true,
    },
  },
  computed: {
    menuList: function () {
      if (
          this.activeIndex.indexOf("/job-list") > -1 ||
          this.activeIndex.indexOf("/job-infos") > -1
      ) {
        return this.menuList2;
      } else {
        return this.menuList1;
      }
    },
    isHome() {
      return ["/", "/home"].includes(this.$route.path);
    },
    homeActive() {
      return this.$store.getters.homeActive;
    },
    headerMenuClass() {
      let result = "";
      if (this.isHome) {
        if (this.homeActive === 1) {
          result = "header-menu light-header-menu";
        } else if (this.homeActive === 2) {
          result = "header-menu light-header-menu";
        } else {
          // result = 'header-menu three-header-menu'
          result = "header-menu light-header-menu";
        }
      } else {
        result =
            (this.headerTheme === "light" || this.headerTheme === "transparent")
                ? "header-menu light-header-menu"
                : "header-menu dark-header-menu";
      }
      return result;
    },
  },
  methods: {
    headerClick(item, index) {
      console.log(item, index);
      // if (item.children || item.type === "solution") {
      //   this.dropVisible = true;
      //   this.dropIndex = index;
      // } else if (item.children || item.type === "production") {
      //   this.dropVisible = true;
      //   this.dropIndex = index;
      // } else {
      this.activeIndex = item.url;
      this.$router.push(item.url);
      // }
    },
    setScreenTopTo0() {
      document.documentElement.scrollTop = 0;
    },
    close() {
      this.dropVisible = false;
      this.curType = "";
    },
    onJump(){
      const url = this.$theme?'https://www.chinaentropy.com/':'https://www.aiotentropy.com/'
      // window.open(url, "_self");
      window.location.replace(url)
    }
  },
};
</script>

<style lang="scss">
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  z-index: 1300;

  & > .el-header {
    width: 100%;
    height: 100px !important;
    display: flex;
    justify-content: center;
    font-size: 14px;
    // opacity: 80%;
    transition: background .3s .4s;

    & > .header-container {
      width: 100%;
      padding: 0 80px;
      padding-right: 36px;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;

        & > .logo {
          width: 119px;
          height: 34px;
          cursor: pointer;
        }
      }

      .line {
        width: 2px;
        height: 30px;
        margin: 0 28px;
        background: #f2f5fc;
        transition: background .3s .4s;
      }

      .text {
        line-height: 24px;

        font-weight: 600;
        color: #f2f5fc;
        font-size: 28px;
        white-space: nowrap;
        transition: color .3s .4s;
      }

      .btn {
        // opacity:26%;
        width: 94px;
        height: 30px;
        background: rgba($color: #d8d8d8, $alpha: 0.26);
        border: 1px solid;
        border-color: rgba($color: #979797, $alpha: 0.26);
        border-radius: 6px;
        font-weight: 600;
        color: #f2f5fc;
        font-size: 18px;
        line-height: 24px;
        cursor: pointer;
        text-align: center;
        margin-left: 24px;
        transition: opacity .3s .4s;
      }

       .light-header-menu {
        & > .menu-item {
          & > span {
            color: #f2f5fc;
          }
        }
      }

       .dark-header-menu {
        & > .menu-item {
          &::after {
            background: #0a0a0a !important;
          }
          & > span {
            color: #0a0a0a;
            font-weight: 500;
          }
        }
      }

       .three-header-menu {
        & > .menu-item {
          & > span {
            color: #8f959e;
          }
        }

        & > .menu-item-active {
          & > span {
            color: #f2f5fc !important;
          }

          &::after {
            background: #f2f5fc !important;
          }
        }
      }
      .right-men {
        display: flex;
        align-items: center;
      }
      .header-menu {
        height: 64px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: space-around;

        & > .menu-item {
          position: relative;
          width: 105px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          cursor: pointer;
          /*text-align: center;*/
          font-size: 18px;
          &::after {
            position: absolute;
            content: "";
            bottom: 0;
            /*left: 50%;*/
            left: 20px;
            width: 0px;
            height: 2px;
            background: #fff;
            /*transform: translateX(-50%);*/
            transition: width .5s;
          }
          &-active {
            & > span {
              font-weight: 600;
              color: #fff;
              transition: color .3s .4s;
            }

            &::after {
              width: 70px;
            }
          }

          & > span {
            transition: color .3s .4s;
            &:hover {
              //color: #fff;
              font-weight: 600;
            }
          }

          & > .drop-block {
            padding: 5px;
            line-height: 36px;
            background: #fff;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);

            & > .drop-item {
              &-active {
                color: #3170ff;
              }

              &:hover {
                color: #3170ff;
              }
            }
          }
        }
        & > .menu-item:hover {
          &::after {
            width: 70px;
          }
        }
        & > .menu-item-home:hover {
          &::after {
            width: 30px;
          }
        }
        & > .menu-item-home.menu-item-active  {
          &::after {
            width: 30px;
            left: 38px;
          }
          
        }

        & > .menu-item-short::after {
          width: 30px;
          left: 35px;
        }

        & > .menu-item-product::after {
          //left: 20px;
        }

        & > .menu-item-home::after {
          left: 38px;
        }
      }
    }
  }

  & > .home-header-one {
    background: rgba(0, 0, 0, 0);
    // backdrop-filter: blur(8px);
  }

  & > .home-header-two {
    background: rgba(0, 0, 0, 0);
    // backdrop-filter: blur(5px);
  }

  & > .light-header {
    //background: rgba($color: #000, $alpha: 0.5);
    background: #000c38;
  }
  & > .transparent-header {
    background: rgba($color: #000, $alpha: 0);
  }
  & > .dark-header {
    background: rgba($color: #fff, $alpha: 1);

    .text {
      color: #0a0a0a !important;
    }

    .line {
      background: #979797 !important;
    }

    .menu-item-active::after {
      background: #0a0a0a !important;
    }

    .menu-item-active > span {
      color: #0a0a0a !important;
    }
  }

  .header-six {
    // background: transparent;
  }
}
</style>
